<template>
    <ContentComp>
        <FormLayout v-if="internalValue != null">
            <FormLayoutRow>
                <FormLayoutLabel>{{ $tm('race.virtualracetype') }}</FormLayoutLabel>

                <div class="d-flex flex-fill">
                    <DropdownSelect
                        :data="virtuelRaceTypesAsSelectLine"
                        v-model="internalValue.VirtualRaceType"
                        caption="race.virtualracetypecaption"
                        class="flex-fill"
                    />
                </div>
            </FormLayoutRow>
            <FormLayoutRow v-if="internalValue.VirtualRaceType == 'ShowUrl'">
                <FormLayoutLabel>{{ $tm('race.virtualracetypeurl') }}</FormLayoutLabel>

                <InputText v-model="internalValue.VirtualRaceExternalURL" />
            </FormLayoutRow>
            <FormLayoutRow>
                <FormLayoutLabel>{{ $tm('race.virtualracetimetype') }}</FormLayoutLabel>

                <div class="d-md-flex gap-5">
                    <InputRadio
                        v-model="internalValue.VirtualTimeType"
                        :name="`timeselect-${internalValue.ID}`"
                        type="radio"
                        translationkey="virtualtimetype.gross"
                        :value="0"
                    />

                    <InputRadio
                        v-model="internalValue.VirtualTimeType"
                        :name="`timeselect-${internalValue.ID}`"
                        type="radio"
                        translationkey="virtualtimetype.net"
                        :value="1"
                    />
                </div>
            </FormLayoutRow>
        </FormLayout>
    </ContentComp>
</template>
<script setup lang="ts">
import { ContentComp, DropdownSelect, InputRadio, InputText } from '@/components';
import { FormLayout, FormLayoutLabel, FormLayoutRow } from '@/components/Form';
import { VirtualRaceTypeValues, type Race } from '@/objects/generated';

// The v-model
const internalValue = defineModel<Race | null>({ required: true });

const virtuelRaceTypesAsSelectLine = VirtualRaceTypeValues.map((val) => ({
    value: val,
    text: `racevirtualtype.${val}`.toLowerCase(),
}));
</script>
